import React, { createContext, useState } from 'react';
import { Outlet } from 'react-router';
import SideBar from './sidebar/SideBar';
import TopBar from './topbar/TopBar';
import { cn } from '../utils/utils';
import { HelpDrawerProvider } from '../pages/help/HelpDrawer';
import { GlobalSearchProvider } from '../components/globalSearch/GlobalSearchProvider';

export interface HeaderRightButton {
    isCancelButton: boolean;
    previousRoute: string;
}

interface HeaderRightButtonContextType {
    buttonState: HeaderRightButton | null;
    setButtonState: React.Dispatch<React.SetStateAction<HeaderRightButton>>;
}

export const HeaderRightButtonContext =
    createContext<HeaderRightButtonContextType>({
        buttonState: null,
        setButtonState: () => {},
    });

const MainLayout = () => {
    const [showSidebar, setShowSidebar] = useState(false);

    const [buttonState, setButtonState] = useState<HeaderRightButton>({
        isCancelButton: false,
        previousRoute: '',
    });

    return (
        <HeaderRightButtonContext.Provider
            value={{ buttonState, setButtonState }}
        >
            <HelpDrawerProvider>
                <GlobalSearchProvider>
                    <TopBar
                        sideBarOpen={showSidebar}
                        onCloseSideBar={() => setShowSidebar(false)}
                        onOpenSideBar={() => setShowSidebar(true)}
                    />
                    <SideBar
                        className={showSidebar ? 'max-w-80' : 'max-w-0 lg:max-w-80'}
                        onHide={() => setShowSidebar(false)}
                    />
                    <main
                        className={cn(
                            'lg:ml-80 pt-20 px-5 min-h-full box-border bg-background transition-margin duration-300 ease-in-out',
                        )}
                    >
                        <Outlet />
                    </main>
                    {showSidebar && (
                        <div className={'fixed inset-0 top-16 bg-foreground/20 z-[1100]'}></div>
                    )}
                </GlobalSearchProvider>
            </HelpDrawerProvider>
        </HeaderRightButtonContext.Provider>
    );
};

export default MainLayout;
